import React from 'react';
import LoginCard from '../components/LoginCard';

const Login = () => {
  return (
    <div className='auth-container'>
        <img src="./Images/banner.png" alt="banner" />
        <LoginCard />
    </div>
  )
}

export default Login